<template>

</template>

<script>
  import 'jquery-validation'
  import 'flatpickr'
  import 'flatpickr/dist/flatpickr.min.css'
  import { Spanish } from 'flatpickr/dist/l10n/es'
  import moment from 'moment'
  
  export default {
    name: 'RegisterProtocolAdvancePeriod',
    mounted () {
      const $startDate = $('#start_date')
      const $endDate   = $('#end_date')

      /**
       * Apply date pickers.
       **/
      const vm = this

      if (window.rpbiCourse) {
        vm.rpbiCourse = window.rpbiCourse
      }
      
      $startDate.flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
        onChange (dates, dateStr, instance) {
          const date = moment(dates[0]).format('DD/MM/YYYY')
          vm.endDate.set('minDate', date)
        },
      })
      
      $endDate.flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
      })

      vm.starDate = $startDate.get(0)._flatpickr
      vm.endDate  = $endDate.get(0)._flatpickr

      if (vm.rpbiCourse) {
        const formattedStartDate = moment(vm.rpbiCourse.start_date).format('DD/MM/YYYY')

        vm.starDate.setDate(formattedStartDate)
        vm.endDate.setDate(moment(vm.rpbiCourse.end_date).format('DD/MM/YYYY'))

        vm.endDate.set('minDate', formattedStartDate)
      }

      /**
       * Init Select2 for search users
       */
      const searchUsers = $('.search-users')

      searchUsers.select2({
        placeholder: 'Buscar usuarios...',
        ajax: {
          url: '/api/v1/users',
          dataType: 'json',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          },
          data(params) {
            return {
              q: params.term,
              page: params.page || 1,
            }
          },
          processResults(data, params) {
            params.page = params.page || 1

            return {
              results: data.data,
              pagination: {
                more: (params.page * 10) < data.meta.total,
              },
            }
          },
        },
      })

      /**
       * Init JQuery validation
       */
      $(() => {
        $('.form').validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            label.addClass('invalid-feedback')
            label.insertAfter(element)
          },
          rules: {
            period: {
              required: true,
            },
            year: {
              required: true,
            },
            start_date: {
              required: true,
            },
            end_date: {
              required: true,
            },
          },
          messages: {
            period: {
              required: 'Este campo es requerido.',
            },
            year: {
              required: 'Este campo es requerido.',
            },
            start_date: {
              required: 'Este campo es requerido.',
            },
            end_date: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler (form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')
            
            form.submit()
          },
        })
      })
    },
  }
</script>
